// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import NavBar from './components/NavBar';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Activities from './pages/Activities';
import CreateActivity from './pages/CreateActivity';
import UserList from './pages/UserList';
import SugarMeasurements from './pages/SugarMeasurements';
import EditActivity from './pages/EditActivity';
import CreateQuestionnaire from './pages/CreateQuestionnaire';
import QuestionnaireList from './pages/QuestionnaireList';
import EditQuestionnaire from './pages/EditQuestionnaire';
import DeleteAccount from './pages/DeleteAccount';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <NavBar />
          <div className="content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/activities" 
                element={
                  <ProtectedRoute>
                    <Activities />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/users" 
                element={
                  <ProtectedRoute>
                    <UserList />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/sugar-measurements/user/:userId" 
                element={
                  <ProtectedRoute>
                    <SugarMeasurements />
                  </ProtectedRoute>
                }     
                />     
              <Route 
                path="/questionnaires/create"
                element={
                  <ProtectedRoute>
                    <CreateQuestionnaire />
                  </ProtectedRoute>
                }    
                />   
              <Route 
                path="/questionnaires"
                element={
                  <ProtectedRoute>
                    <QuestionnaireList />
                  </ProtectedRoute>
                }    
                />          
              <Route 
                path="/questionnaires/edit/:id"
                element={
                  <ProtectedRoute>
                    <EditQuestionnaire />
                  </ProtectedRoute>
                }    
                />                                           
              <Route path="/activities/edit/:id" element={<EditActivity />} />
              <Route path="/delete-account" element={<DeleteAccount />} />

              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route 
                path="/create-activity" 
                element={
                  <ProtectedRoute>
                    <CreateActivity />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;